/** Shown when a new password matches the user's current or previous password (BFP-517). */
export const NEW_PASSWORD_MUST_DIFFER_MESSAGE =
  'New password cannot be the same as your previous password.'
